import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxHeight: 20,
  viewboxWidth: 20,
};

const DownloadIcon = ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      viewboxHeight={viewboxHeight}
      viewboxWidth={viewboxWidth}
      {...rest}
    >
      <path
        d="M3.5535 8.2008C3.61128 8.2609 3.6806 8.30872 3.75731 8.34139C3.83401 8.37405 3.91653 8.39089 3.9999 8.39089C4.08327 8.39089 4.16579 8.37405 4.24249 8.34139C4.3192 8.30872 4.38852 8.2609 4.4463 8.2008L7.1463 5.2008C7.22373 5.11454 7.27451 5.00771 7.29252 4.89321C7.31053 4.77871 7.29498 4.66144 7.24777 4.55558C7.20055 4.44973 7.12368 4.35981 7.02646 4.29671C6.92923 4.23361 6.81581 4.20002 6.6999 4.2H4.8999L4.8999 0.899998C4.8999 0.661303 4.80508 0.432385 4.6363 0.263602C4.46751 0.0948191 4.2386 -1.90735e-06 3.9999 -1.90735e-06C3.76121 -1.90735e-06 3.53229 0.0948191 3.3635 0.263602C3.19472 0.432385 3.0999 0.661303 3.0999 0.899998V4.2H1.2999C1.18399 4.20002 1.07057 4.23361 0.973345 4.29671C0.87612 4.35981 0.799253 4.44973 0.752037 4.55558C0.70482 4.66144 0.689276 4.77871 0.707282 4.89321C0.725288 5.00771 0.776074 5.11454 0.853501 5.2008L3.5535 8.2008Z"
        fill="currentColor"
      />
      <path
        d="M0.999903 12H6.9999C7.2386 12 7.46752 11.9052 7.6363 11.7364C7.80508 11.5676 7.8999 11.3387 7.8999 11.1C7.8999 10.8613 7.80508 10.6324 7.6363 10.4636C7.46752 10.2948 7.2386 10.2 6.9999 10.2H0.999903C0.761208 10.2 0.53229 10.2948 0.363507 10.4636C0.194725 10.6324 0.0999026 10.8613 0.0999026 11.1C0.0999026 11.3387 0.194725 11.5676 0.363507 11.7364C0.53229 11.9052 0.761208 12 0.999903 12V12Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default DownloadIcon;
